import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { TraineeSubscription } from "../../Models/Trainee";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { Router } from "../../Handlers/Router";
import Profile from "../../../Component/Client/Profile";

export class AddTransactionVM extends InterActive{
    private data:TraineeSubscription
    private transactionData:{trainee_id:string , level_specialization_trainee_id:string ,account_id:string , verification?:string|null ,  paid:string , date:string , img:File|null , additional:string , notes:string}={trainee_id:'' , level_specialization_trainee_id:'' , account_id:'' , paid:'0' , date:'' , img:null , additional:'' , notes:''}
    private accountsList:{id:string , name:string , banck_account_id:string , currency:{id:string , account:string , arabic_currency_name:string , english_currency_name:string , price:number } }[] = []
    private id:string = ''
    private name:string = ''
    private currencyPrice:number = 0
    private localDeserved:number= 0

    private clearImg:()=>void = ()=>{};
    public get ClearImg():()=>void{ return this.clearImg  }
    public set ClearImg(value:()=>void){ this.clearImg = value ; this.update()  }

    public get Data():{account_id:string, paid:string , date:string, img:File|null, additional:string, verification?:string|null  , notes:string}{ return this.transactionData }
    public get Accounts():{id:string , name:string , banck_account_id:string , currency:{id:string , account:string , arabic_currency_name:string , english_currency_name:string , price:number } }[]{ return this.accountsList }
    public get Id():string { return this.id }
    public get Name():string { return this.name }
    public get Deserved():string { return (Number(this.data.subscription.price)-Number(this.data.subscription.discount)-Number(this.data.subscription.paid)).toString() }
    public get Remainning():string { return (Number(this.data.subscription.price)-Number(this.data.subscription.discount)-Number(this.data.subscription.paid)-Number(this.transactionData.paid)).toString() }
    public get Price():string { return  this.data.subscription.price }
    public get LocalPrice():number{ return this.localDeserved }
    public get CurrencyPrice():number { return this.currencyPrice }

    public set AccountId(value:string ){ this.transactionData.account_id = value;this.CurrencyPrice = this.accountsList.find(a=>a.id===value)?.currency.price||0; this.transactionData.paid = '0';  this.update() }
    public set Paid(value:string ){ this.transactionData.paid = Number(GeneralMethods.removeNonPositiveFloatNumeric(value))<0 ?'0':(Number(GeneralMethods.removeNonPositiveFloatNumeric(value)) > (this.localDeserved)?(this.localDeserved):GeneralMethods.removeNonPositiveFloatNumeric(value)).toString();  this.update() }
    public set Date(value:string){ this.transactionData.date = value; this.update() }
    public set Image(value:File|null){ this.transactionData.img = value; this.update() }
    public set Additional(value:string){ this.transactionData.additional = GeneralMethods.removeNonFloatNumeric(value); this.update() }
    public set Notes(value:string){ this.transactionData.notes = value; this.update() }
    public set Verification(value:string){ this.transactionData.verification = value; this.update() }
    private set CurrencyPrice(value:number){ this.currencyPrice = value; this.localDeserved = Math.ceil( Number(this.Deserved)*value *100)/100 }


    constructor(data:TraineeSubscription , id:string , name:string){
        super()
        this.data = data
        this.id = id 
        this.name = name
        this.transactionData.trainee_id = id
        this.transactionData.level_specialization_trainee_id = data.subscription.id
        this.transactionData.verification = data.subscription.verification==='verify'?null:undefined
        if(this.accountsList.length==0)this.getAccounts()
    }

    public getAccounts(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAccounts()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.accountsList = response.data.data
                                this.AccountId = this.accountsList[0].id
                                this.update()
                            }else Notify({type:'danger' , title:'حدثت مشكلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'حدثت مشكلة' , body:'حدثت مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{  Notify({type:'danger' , title:'حدثت مشكلة' , body:'حدثت مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
            }
        )
    }

    public send(){
        if(this.validate()){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.addTransaction(this.getFormData())
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    Notify({type:'success' , title:'عملية ناجحة' ,body:'تم تسجيل التحويل بنجاح'})
                                    Router.OpenNormalPage(<Profile id={this.id}/>)
                                }else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                            }else  Notify({type:'danger' , title:'فشل العملية', body:'فشل عملية تسجيل التحويل'})
                        }
                    }catch{  Notify({type:'danger' , title:'فشل العملية', body:'فشل عملية تسجيل التحويل'}) }
                }
            )
        }
    }

    private validate(){
        if(!this.transactionData.account_id){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء اختيار الحساب'}); return false; }
        if(!this.transactionData.paid){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء ادخال المبلغ المدفوع'}); return false; }
        if(!this.transactionData.date){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء ادخال تاريخ التحويل'}); return false; }
        if(this.transactionData.img === null){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء ادخال صورة الايصال'}); return false; }
        else return true;
    }
    private getFormData(){
        const formData = new FormData()
        formData.append('trainee_id' , this.transactionData.trainee_id)
        formData.append('level_specialization_trainee_id' , this.transactionData.level_specialization_trainee_id)
        formData.append('account_id' , this.transactionData.account_id)
        formData.append('value' , this.transactionData.paid)
        formData.append('date' , this.transactionData.date)
        formData.append('additional',this.transactionData.additional)
        formData.append('notes', this.transactionData.notes)
        if(this.transactionData.img)formData.append( 'img' , this.transactionData.img)
        if(this.transactionData.verification)formData.append( 'verification' , this.transactionData.verification)

        return formData
    }

}